import { useState } from 'react'
import { useNavigate } from 'react-router'

import { useDate, useInitData } from '../../../../../hooks'
import { isCalendarSettingsAvailable } from '../../../../../utils/calendar'
import { useCalendarGrid } from '../../../../CalendarGrid'
import {
  useCalendarActionToken,
  useCalendarItemsLoader,
} from '../../../Calendar.hooks'
import { getIsCalendarTaskDeadline } from '../../../Calendar.utils'
import { CALENDAR_VIEW_SETTINGS_PATH } from '../../CalendarView.constants'
import { getCalendarViewRequestKey } from '../../CalendarView.utils'
import { useCalendarViewFollowUpMove } from '../useCalendarViewFollowUpMove'
import { useCalendarViewRelieveDay } from '../useCalendarViewRelieveDay'
import { useCalendarViewTaskMove } from '../useCalendarViewTaskMove'

export function useCalendarView({ filters, initialMode, modes, onChangeMode }) {
  const navigate = useNavigate()

  const { availableSections, sections } = useInitData()

  const [modal, setModal] = useState(null)

  const today = useDate()

  const { getItems } = useCalendarItemsLoader(filters)

  const calendar = useCalendarGrid({
    getItems,
    initialMode,
    isEnabled: true,
    modes,
    requestKey: getCalendarViewRequestKey({ filters, today }),
    onChangeMode,
  })

  const { getActionToken, handleStartAction } = useCalendarActionToken()

  function handleCloseModal() {
    setModal(null)
  }

  const modalParams = {
    getActionToken,
    setModal,
    onClose: handleCloseModal,
    onReload: calendar.handleReload,
  }

  const { handleMoveFollowUp } = useCalendarViewFollowUpMove(modalParams)

  const { handleOpenTaskMove } = useCalendarViewTaskMove(modalParams)

  const { handleOpenRelieveDay } = useCalendarViewRelieveDay(modalParams)

  // TODO: open a task deadline in the task modal (getTask + TaskFormModal)
  // once the feed returns real task ids, and an appointment in its detail
  // panel once it exists.
  function handleClickItem(item) {
    if (item.url) {
      navigate(item.url)
    }
  }

  function handleMoveItem(item, date) {
    handleStartAction()

    if (getIsCalendarTaskDeadline(item)) {
      handleOpenTaskMove({ date, item })
    } else {
      handleMoveFollowUp({ date, item })
    }
  }

  function handleOpenSettings() {
    navigate(CALENDAR_VIEW_SETTINGS_PATH)
  }

  return {
    calendar,
    canOpenSettings: isCalendarSettingsAvailable({
      availableSections,
      sections,
    }),
    handleClickItem,
    handleMoveItem,
    handleOpenRelieveDay,
    handleOpenSettings,
    handleStartAction,
    modal,
  }
}
